import React, { useState } from "react";
import { API } from "../../../API";
import { toast } from "react-toastify";
import DeleteConfirmation from "../../models/DeleteConfirmation";
import UpdateCourseModelSubAdmin from "../../models/course/UpdateCourseModelSubAdmin";

const CourseTableSubAdmin = ({ data, reload, branchId }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [editPopupShow, setEditPopupShow] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState({});

  const deleteCourse = async (id) => {
    try {
      const { data } = await API.delete(`/course/delete/${id}`);
      if (data.success) {
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
      setShowConfirmation(false);
      reload();
      setSelectedCourse({});
    } catch (error) {
      toast.error(error.response.data.message);
      console.log("error in delete Course:", error);
    }
  };

  return (
    <div>
      <div className="rounded-t text-white flex items-center justify-center mt-4 px-6 py-2 font-bold text-xl border-b border-gray-100 bg-primary">
        Course List
      </div>
      <div className="overflow-x-auto overflow-y-auto relative h-[85vh]">
        <table className="border-collapse table-auto table-striped relative min-w-full divide-y divide-gray-200">
          <thead className="">
            <tr className="sticky top-0 bg-gray-100 text-base font-bold text-gray-500 uppercase  z-10">
              <th
                scope="col"
                className="px-6 py-3 text-left tracking-wider sticky left-0 bg-gray-100"
              >
                No
              </th>
              <th scope="col" className="px-6 py-3 text-left tracking-wider">
                Course Name
              </th>
              <th scope="col" className="px-6 py-3 text-left tracking-wider">
                Amount
              </th>
              <th scope="col" className="px-6 py-3 text-left tracking-wider">
                Branch Name
              </th>
              <th scope="col" className="px-6 py-3 text-left tracking-wider">
                Update
              </th>
              <th scope="col" className="px-6 py-3 text-left tracking-wider">
                Delete
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {data.map((branch, i) => (
              <tr key={i} className="text-lg text-gray-900">
                <td className="px-6 py-4 whitespace-nowrap sticky left-0 bg-white">
                  <div className="flex items-center">
                    <div>{i + 1}</div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div>{branch?.name}</div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div>{branch?.amount ? branch?.amount : "-"}</div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center">
                    <div>
                      {branch?.branchId?.name ? branch?.branchId?.name : "-"}
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span
                    onClick={() => {
                      setSelectedCourse(branch);
                      setEditPopupShow(true);
                    }}
                    className="cursor-pointer inline-flex leading-5 text-white  bg-blue-600 hover:bg-blue-700  font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2"
                  >
                    Update
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span
                    onClick={() => {
                      setSelectedCourse(branch);
                      setShowConfirmation(true);
                    }}
                    className="cursor-pointer inline-flex leading-5 text-white  bg-primary hover:bg-red-700  font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2"
                  >
                    Delete
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showConfirmation && (
        <DeleteConfirmation
          msg={`Are you sure you want to delete ${selectedCourse?.name} branch ?`}
          close={setShowConfirmation}
          task={() => deleteCourse(selectedCourse?._id)}
        />
      )}

      <UpdateCourseModelSubAdmin
        key={selectedCourse?._id}
        show={editPopupShow}
        close={setEditPopupShow}
        data={selectedCourse}
        reload={reload}
      />
    </div>
  );
};

export default CourseTableSubAdmin;
